function calculatePolygonArea(points) {
  if (points.length < 3) return 0;

  // Use spherical geometry for more accurate area calculation
  const R = 6378137; // Earth's radius in meters
  const toRadians = (degrees) => degrees * (Math.PI / 180);

  // Calculate area using spherical excess formula
  let area = 0;
  const n = points.length;

  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    const lat1 = toRadians(points[i].lat);
    const lng1 = toRadians(points[i].lng);
    const lat2 = toRadians(points[j].lat);
    const lng2 = toRadians(points[j].lng);

    area += lng2 * Math.sin(lat1) - lng1 * Math.sin(lat2);
  }

  area = Math.abs(area) * R * R / 2;

  return area;
}

function calculateLineLength(points) {
  if (points.length < 2) return 0;

  const R = 6378137; // Earth's radius in meters
  const toRadians = (degrees) => degrees * (Math.PI / 180);

  let totalLength = 0;

  for (let i = 0; i < points.length - 1; i++) {
    const lat1 = toRadians(points[i].lat);
    const lng1 = toRadians(points[i].lng);
    const lat2 = toRadians(points[i + 1].lat);
    const lng2 = toRadians(points[i + 1].lng);

    // Haversine formula for great circle distance
    const dLat = lat2 - lat1;
    const dLng = lng2 - lng1;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(lat1) * Math.cos(lat2) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    totalLength += distance;
  }

  return totalLength;
}

function calculateDistance(point1, point2) {
  if (!point1 || !point2) return 0;

  return calculateLineLength([point1, point2]);
}

export { calculatePolygonArea, calculateLineLength, calculateDistance };